import { useEffect, useState } from 'react';
import type { MarketplaceProduct } from '@/types';
import { marketplaceService } from '@/services/marketplace/marketplaceService';
import { aiMarketplaceService } from '@/services/marketplace/aiMarketplaceService';

interface Opts {
  industryIds?: string[];
  category?: string;
  excludeId?: string;
  count?: number;
}

/** Agent 1 — personalized product recommendations. */
export function useAIRecommendations(opts: Opts = {}) {
  const [items, setItems] = useState<MarketplaceProduct[]>([]);
  const [loading, setLoading] = useState(true);
  // Primitive deps so the effect doesn't refire on a new object each render.
  const industryKey = (opts.industryIds ?? []).join(',');
  const { category, excludeId, count } = opts;

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      setLoading(true);
      const all = await marketplaceService.listAll();
      const recs = aiMarketplaceService.recommend(all, {
        industryIds: industryKey ? industryKey.split(',') : [],
        category,
        excludeId,
        count,
      });
      if (!cancelled) {
        setItems(recs);
        setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [industryKey, category, excludeId, count]);

  return { items, loading };
}
